import script from "./YoutubeThumbnailView.vue?vue&type=script&setup=true&lang=js"
export * from "./YoutubeThumbnailView.vue?vue&type=script&setup=true&lang=js"

import "./YoutubeThumbnailView.vue?vue&type=style&index=0&id=088d7841&lang=scss"

const __exports__ = script;

export default __exports__